@let deliveryMethod = form.controls.deliveryMethod.value;

<form
  class="pt-delivery-form"
  [formGroup]="form"
  (ngSubmit)="save()"
>
  <div class="pt-delivery-form__tabs">
    <button
      class="pt-delivery-form__tab"
      [class.pu-button_pressed]="deliveryMethod !== 'pickup'"
      type="button"
      puButton
      uiType="gradient"
      size="m"
      (click)="setDelivery()"
    >
      {{ 'deliveryForm.tab.delivery' | translate }}
    </button>

    @if (hasPickupFromOffice) {
      <button
        class="pt-delivery-form__tab"
        [class.pu-button_pressed]="deliveryMethod === 'pickup'"
        type="button"
        puButton
        uiType="gradient"
        size="m"
        (click)="setOffice()"
      >
        <span class="pt-delivery-form__tab-text">
          {{ 'deliveryForm.tab.selfPickup' | translate }}
        </span>

        <span class="pt-delivery-form__tab-text-desktop">
          {{ 'deliveryForm.tab.office' | translate }}
        </span>
      </button>
    }
  </div>

  <div class="pu-form-group">
    <pu-simple-input
      formControlName="firstName"
      [label]="'deliveryForm.input.firstName*' | translate"
    />

    <pu-simple-input
      formControlName="lastName"
      [label]="'deliveryForm.input.lastName*' | translate"
    />
  </div>

  @if (deliveryMethod !== 'pickup') {
    <div class="pu-form-group">
      <pu-select
        formControlName="deliveryMethod"
        [label]="'deliveryForm.select.deliveryMethod*' | translate"
        [items]="deliveryMethods"
      />

      <pu-simple-input
        formControlName="phone"
        [controlType]="controlTypes.Tel"
        [label]="'deliveryForm.input.phoneNumber*' | translate"
      />
    </div>
  }

  @switch (deliveryMethod) {
    @case ('pickup') {
      <pt-delivery-pickup
        [form]="form"
        [order]="order()"
        [pickupLocations]="pickupLocations()"
        (locationChanged)="locationChanged.emit($event)"
      />
    }
    @case ('international') {
      <pt-delivery-international
        [form]="form"
        [order]="order()"
      />
    }
    @case ('ukrposhta') {
      <pt-delivery-ukrposhta
        [form]="form"
        [order]="order()"
      />
    }
    @case ('nova_poshta') {
      <pt-delivery-nova-poshta
        [form]="form"
        [order]="order()"
      />
    }
    @case ('fedex') {
      <pt-delivery-fedex
        [form]="form"
        [order]="order()"
      />
    }
    @case ('dhl') {
      <pt-delivery-dhl
        [form]="form"
        [order]="order()"
      />
    }
    @case ('dpd') {
      <pt-delivery-dpd
        [form]="form"
        [order]="order()"
      />
    }
    @case ('inpost') {
      <pt-delivery-inpost
        [form]="form"
        [order]="order()"
      />
    }
    @case ('acs') {
      <pt-delivery-acs
        [form]="form"
        [order]="order()"
      />
    }
    @case ('gap_akis_express') {
      <pt-delivery-gap-akis-express
        [form]="form"
        [order]="order()"
      />
    }
  }

  <pu-simple-input
    formControlName="comment"
    [label]="'deliveryForm.input.comment' | translate"
  />

  @if (isPaidInternationalShipping) {
    <span class="pt-delivery-form__international-attention">
      {{ 'deliveryForm.internationalAttention' | translate }}
    </span>
  }

  <div class="pt-delivery-form__controls">
    <button
      class="pt-delivery-form__controls-btn md:pu-button_l"
      type="submit"
      puButton
      uiType="primary"
      size="m"
      [disabled]="form.invalid || !order().products.length"
    >
      {{ 'deliveryForm.controls.placeOrder' | translate }}
    </button>

    <a
      class="pt-delivery-form__controls-btn md:pu-button_l"
      puButton
      uiType="secondary"
      size="m"
      [routerLink]="cancelLink()"
    >
      {{ cancelName() }}
    </a>
  </div>
</form>
